export const STATUS_BADGE_VARIANT_STYLES = {
	success: {
		background: "var(--fds-success, #248a3d)",
		color: "var(--fds-on-success, #fafffb)",
	},
	pending: {
		background: "var(--fds-pending, #ffca3d)",
		color: "var(--fds-on-pending, #1f1700)",
	},
	neutral: {
		background: "var(--fds-surface-container-high, #dfdfdf)",
		color: "var(--fds-on-surface-container, #00071f)",
	},
	dark: {
		background: "#1b1b20",
		color: "#ffffff",
	},
	primary: {
		background: "var(--fds-primary, #0d6efd)",
		color: "var(--fds-on-primary, #ffffff)",
	},
};

export function statusBadgeStyle(variant) {
	const { background, color } =
		STATUS_BADGE_VARIANT_STYLES[variant] ||
		STATUS_BADGE_VARIANT_STYLES.neutral;
	return `background-color: ${background}; color: ${color};`;
}
